import { Box } from "@otrium/core";
import { Button, Dropdown, Flag } from "../LanguageSwitcher.styled";

type ToggleProps = {
  isOpen?: boolean;
  onToggle?: () => void;
  isFooter: boolean;
  svgPrefixId: string;
  children?: React.ReactNode;
};

function Toggle({
  isOpen,
  onToggle,
  isFooter,
  svgPrefixId,
  children,
  ...buttonAttrs
}: ToggleProps) {
  return (
    <Button
      className={isFooter ? "footer" : ""}
      onPress={onToggle}
      {...buttonAttrs}
    >
      <Box height="20px" mr={1}>
        <Flag svgPrefixId={svgPrefixId} />
      </Box>
      {children}
      <Dropdown open={isOpen} isFooter={isFooter} />
    </Button>
  );
}

export { Toggle };
